import { Button, Form } from "devextreme-react";
import { GroupItem, Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import React, { useEffect, useRef, useState } from "react";
import BaseFormWithBreadCrumbs from "../../../components/base-form/base-form";
import { useScreenSize } from "../../../utils/media-query";
import { getPropsDateEdit, getSelectBoxPropertiesIdText } from "../../../utils/default-props";
import ProfilePhoto from "./profile-photo/profile-photo";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useAuth } from "../../../contexts/auth";
import { lookupGroups } from "../../../utils/lookup-groups.ts";



function Identity({ employeeId, setEmployeeId, setEmployee }) {

    const [formData, setFormData] = useState(
        {
            identityNumber: null,
            name: "",
            surname: "",
            motherName: "",
            fatherName: "",
            birthDate: "",
            genderId: "",
            maritalStatusId: "",
            nationalityId: "",
            bloodTypeId: "",
            disabilityStatusId: "",
            id: "",
        }
    )
    const [readOnly, setReadOnly] = useState(false)// base de yetkiye göre bakılacak
    const [dirty, setDirty] = useState(false)
    const screenSize = useScreenSize()
    const formRef = useRef()
    const [maritalStatusList, setMaritalStatusList] = useState()
    const [bloodTypeList, setBloodTypeList] = useState()
    const [disabilityStatusList, setDisabilityStatusList] = useState()
    const [genderList, setGenderList] = useState()
    const [nationalityList, setNationalityList] = useState()

    const { getLookupData } = useLookupGroup()
    const { activeLanguage } = useAuth()

    const genderOptions = {
        // dataSource: useMemo(() => dataSourceHR({
        //     loadUrl: `/api/LookupData/LookupGroup/${lookupGroups.Gender}`,
        // }), []),
        items: genderList,
        ...getSelectBoxPropertiesIdText
    }

    const maritalStatusOption = {
        items: maritalStatusList,
        ...getSelectBoxPropertiesIdText,

    }

    const nationalityOptions = {
        items: nationalityList,
        ...getSelectBoxPropertiesIdText,
    }

    const bloodTypeOptions = {
        items: bloodTypeList,
        ...getSelectBoxPropertiesIdText
    }

    const disabilityStatusOptions = {
        items: disabilityStatusList,
        ...getSelectBoxPropertiesIdText
    }

    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    useEffect(() => {
        if (employeeId && formData.name)
            setEmployee(`${formData.name} ${formData.surname}`)
        else
            setEmployee(employeeId)

    }, [formData.name])

    useEffect(() => {
        getLookupData(lookupGroups.maritalStatus).then(response => setMaritalStatusList(response))
        getLookupData(lookupGroups.bloodType).then(response => setBloodTypeList(response))
        getLookupData(lookupGroups.disabilityStatus).then(response => setDisabilityStatusList(response))
        getLookupData(lookupGroups.gender).then(response => setGenderList(response))
        getLookupData(lookupGroups.nationality).then(response => setNationalityList(response))

    }, [activeLanguage])

    return (
        <React.Fragment>
            <BaseFormWithBreadCrumbs
                readOnly={readOnly}
                setReadOnly={setReadOnly}
                formData={formData}
                setFormData={setFormData}
                dirty={dirty}
                setDirty={setDirty}
                formRef={formRef}
                loadId={employeeId}
                setId={setEmployeeId}
                loadUrl={"/api/Employee/"}
                updateUrl={"/api/Employee/FormData"}
            >
                <Form
                    width={700}
                    labelLocation={screenSize.isXSmall ? "top" : "left"}
                    formData={formData}
                    readOnly={readOnly}
                    onFieldDataChanged={handleFieldDataChanged}
                    ref={formRef}
                >
                    <GroupItem
                    //colCountByScreen={colCountByScreen}
                    >
                        <GroupItem caption="Kimlik Bilgileri" colCount={2} colSpan={2} >
                            <GroupItem cssClass="ortala">
                                <SimpleItem>
                                    <ProfilePhoto employeeId={employeeId} />
                                </SimpleItem>

                                {/* <SimpleItem >
                                    <img width={200} src="img/oktay.jpg" alt="" />
                                </SimpleItem>
                                <SimpleItem cssClass="ortala">
                                    <Button text="Yükle"></Button>
                                </SimpleItem> */}
                            </GroupItem>
                            <GroupItem >
                                <SimpleItem dataField="identityNumber" editorType="dxTextBox">
                                    <Label text="Kimlik No" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="name" editorType="dxTextBox">
                                    <Label text="Adı" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="surname" editorType="dxTextBox">
                                    <Label text="Soyadı" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="motherName" editorType="dxTextBox">
                                    <Label text="Ana Adı" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="fatherName" editorType="dxTextBox">
                                    <Label text="Baba Adı" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="birthDate"
                                    {...getPropsDateEdit}
                                >
                                    <Label text="Dogum Tarihi" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="genderId" editorType="dxSelectBox" editorOptions={genderOptions} >
                                    <Label text="Cinsiyeti" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="maritalStatusId" editorType="dxSelectBox" editorOptions={maritalStatusOption}>
                                    <Label text="Medeni Hali" />
                                </SimpleItem>
                                <SimpleItem dataField="nationalityId" editorType="dxSelectBox" editorOptions={nationalityOptions}>
                                    <Label text="Uyruğu" />
                                </SimpleItem>
                                <SimpleItem dataField="bloodTypeId" editorType="dxSelectBox" editorOptions={bloodTypeOptions}>
                                    <Label text="Kan Grubu" />
                                </SimpleItem>
                                <SimpleItem dataField="disabilityStatusId" editorType="dxSelectBox" editorOptions={disabilityStatusOptions}>
                                    <Label text="Engel Durumu" />
                                </SimpleItem>
                            </GroupItem>
                        </GroupItem>
                    </GroupItem>
                </Form>
            </BaseFormWithBreadCrumbs>

        </React.Fragment>
    )
}



export default Identity
